import logoSrc from "@/assets/twss-logo.png";

// The master mark: the supplied circular record-label artwork, clipped to a
// clean circle so it reads as a physical record — never recreated in CSS.
export default function RecordLogo({
  size = 320,
  spin = true,
  shadow = true,
  className = "",
  testid = "master-record-logo",
}) {
  return (
    <div
      data-testid={testid}
      aria-hidden="true"
      className={`relative shrink-0 overflow-hidden rounded-full ${shadow ? "record-shadow" : ""} ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={logoSrc}
        alt=""
        draggable="false"
        className={`h-full w-full select-none rounded-full object-cover ${
          spin ? "animate-spin-slowest" : ""
        }`}
        style={{ willChange: "transform" }}
      />
      {/* spindle glint */}
      <span
        className="pointer-events-none absolute left-1/2 top-1/2 h-[7%] w-[7%] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(244,236,225,0.7), transparent 70%)" }}
      />
    </div>
  );
}
